import React from 'react';

const Privacy = () => {
  return (
    <div className="container px-4 pt-24 mx-auto md:pt-32 lg:px-0 dark:bg-gray-900">
      <h2 class="text-2xl font-bold dark:text-white">Privacy Policy</h2>
      <p class="mt-10 text-lg md:text-md text-gray-500 dark:text-gray-400">
        At TOOlover, accessible from <strong class="font-semibold text-gray-900 dark:text-white">https://toolover.pro</strong>, one of our main priorities is the privacy of our visitors. This Privacy Policy document contains types of information that is collected and recorded by TOOlover and how we use it.
      </p>
      <p class="mt-3 text-lg md:text-md text-gray-500 dark:text-gray-400">
        If you have additional questions or require more information about our Privacy Policy, do not hesitate to contact us.
      </p>
      <p class="mt-3 text-lg md:text-md text-gray-500 dark:text-gray-400">
        This Privacy Policy applies only to our online activities and is valid for visitors to our website with regards to the information that they shared and/or collect in TOOlover. This policy is not applicable to any information collected offline or via channels other than this website.
      </p>
      <h2 class="mt-10 text-2xl font-bold dark:text-white">Consent</h2>
      <p class="mt-3 text-lg md:text-md text-gray-500 dark:text-gray-400">
        By using our website, you hereby consent to our Privacy Policy and agree to its terms.
      </p>
      <h2 class="mt-10 text-2xl font-bold dark:text-white">Information we collect</h2>
      <p class="mt-3 text-lg md:text-md text-gray-500 dark:text-gray-400">
        The personal information that you are asked to provide, and the reasons why you are asked to provide it, will be made clear to you at the point we ask you to provide your personal information.
      </p>
      <p class="mt-3 text-lg md:text-md text-gray-500 dark:text-gray-400">
        If you contact us directly, we may receive additional information about you such as your name, email address, phone number, the contents of the message and/or attachments you may send us, and any other information you may choose to provide.
      </p>
      <p class="mt-3 text-lg md:text-md text-gray-500 dark:text-gray-400">
        When you register for an Account, we may ask for your contact information, including items such as name, company name, address, email address, and telephone number.
      </p>
      <h2 class="mt-10 text-2xl font-bold dark:text-white">How we use your information</h2>
      <p class="mt-3 text-lg md:text-md text-gray-500 dark:text-gray-400">
        We use the information we collect in various ways, including to:
      </p>
      <ul class="mt-2 list-disc list-inside text-lg md:text-md text-gray-500 dark:text-gray-400">
        <li className='mt-2'>Provide, operate, and maintain our website</li>
        <li className='mt-2'>Improve, personalize, and expand our website</li>
        <li className='mt-2'>Understand and analyze how you use our website</li>
        <li className='mt-2'>Develop new products, services, features, and functionality</li>
        <li className='mt-2'>Communicate with you, either directly or through one of our partners, including for customer service, to provide you with updates and other information relating to the website, and for marketing and promotional purposes
        </li>
        <li className='mt-2'>Send you emails</li>
        <li className='mt-2'>Find and prevent fraud</li>
      </ul>
      <h2 class="mt-10 text-2xl font-bold dark:text-white">Changes to This Privacy Policy</h2>
      <p class="mt-3 text-lg md:text-md text-gray-500 dark:text-gray-400">
        We may update our Privacy Policy from time to time. Thus, we advise you to review this page periodically for any changes. We will notify you of any changes by posting the new Privacy Policy on this page. These changes are effective immediately, after they are posted on this page.
      </p>
      <h2 class="mt-10 text-2xl font-bold dark:text-white">Contact Us</h2>
      <p class="mt-3 text-lg md:text-md text-gray-500 dark:text-gray-400">
        If you have any questions or suggestions about our Privacy Policy, do not hesitate to contact us.
      </p>
    </div>
  )
}

export default Privacy;